import { render, staticRenderFns } from "./OrdenProduccion.vue?vue&type=template&id=a5062e82&"
import script from "./OrdenProduccion.vue?vue&type=script&lang=js&"
export * from "./OrdenProduccion.vue?vue&type=script&lang=js&"
import style0 from "./OrdenProduccion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports